import DomainCommon from './common'

const SurveyService = {
    survey: () => new Promise((resolve, reject) =>
        DomainCommon.fetchGet({
            url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/survey/links`,
            resolve, reject
        })),
}

export default SurveyService



// WEBPACK FOOTER //
// ./src/service/survey.js